module.exports = __webpack_public_path__ + "img/gzone.40da4394.png";